import type { ContentBlock } from '../../types';

export const h = (text: string, level: 1 | 2 | 3 = 2): ContentBlock => ({
  type: 'heading',
  text,
  level,
});

export const p = (text: string): ContentBlock => ({
  type: 'paragraph',
  text,
});

export const list = (steps: string[]): ContentBlock => ({
  type: 'step-list',
  steps,
});

export const checklist = (
  id: string,
  items: string[],
  title?: string
): ContentBlock => ({
  type: 'checklist',
  id,
  items,
  title,
});

export const tip = (text: string): ContentBlock => ({
  type: 'tip',
  text,
});

export const warning = (text: string): ContentBlock => ({
  type: 'warning',
  text,
});
